/* eslint semi:0 */
import { makeSafeFn } from '../../utils/fn'

let facebookPixelScriptConfig = {
  name: 'facebookPixel',
  src: 'https://connect.facebook.net/en_US/fbevents.js',
  beforeLoad: makeSafeFn(function beforeFbPixelLoad() {
    // All this shit is taken from FB documentation on how to implement the pixel, but I changed it to minimum. Without it, it doesn't work
    window._fbq = window.fbq = function() {
      window.fbq.callMethod
        ? window.fbq.callMethod.apply(window.fbq, arguments)
        : window.fbq.queue.push(arguments)
    }
    window.fbq.push = window.fbq
    window.fbq.loaded = !0
    window.fbq.version = '2.0'
    window.fbq.queue = []
  }),
}

export default facebookPixelScriptConfig



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/facebookPixelScript.js